const MdContent = ({ content }) => {

  return (
    <div className="formatted_long_text" dangerouslySetInnerHTML={{ __html: content }} />
  );
}

export default MdContent;